export default __webpack_public_path__ + "static/media/va.7bea3a0e.svg";